"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventType = exports.BpmnType = void 0;
/**
 * Contains a list of all known BPMN types and maps them to their corresponding XML tag.
 */
var BpmnType;
(function (BpmnType) {
    BpmnType["emptyActivity"] = "bpmn:Task";
    BpmnType["businessRuleTask"] = "bpmn:BusinessRuleTask";
    BpmnType["userTask"] = "bpmn:UserTask";
    BpmnType["exclusiveGateway"] = "bpmn:ExclusiveGateway";
    BpmnType["parallelGateway"] = "bpmn:ParallelGateway";
    BpmnType["serviceTask"] = "bpmn:ServiceTask";
    BpmnType["startEvent"] = "bpmn:StartEvent";
    BpmnType["endEvent"] = "bpmn:EndEvent";
    BpmnType["intermediateCatchEvent"] = "bpmn:IntermediateCatchEvent";
    BpmnType["intermediateThrowEvent"] = "bpmn:IntermediateThrowEvent";
    BpmnType["scriptTask"] = "bpmn:ScriptTask";
    BpmnType["boundaryEvent"] = "bpmn:BoundaryEvent";
    BpmnType["callActivity"] = "bpmn:CallActivity";
    BpmnType["subProcess"] = "bpmn:SubProcess";
    BpmnType["manualTask"] = "bpmn:ManualTask";
    BpmnType["complexGateway"] = "bpmn:ComplexGateway";
    BpmnType["inclusiveGateway"] = "bpmn:InclusiveGateway";
    BpmnType["eventBasedGateway"] = "bpmn:EventBasedGateway";
    BpmnType["sendTask"] = "bpmn:SendTask";
    BpmnType["receiveTask"] = "bpmn:ReceiveTask";
})(BpmnType = exports.BpmnType || (exports.BpmnType = {}));
/**
 * Contains a list of all supported event types.
 */
var EventType;
(function (EventType) {
    EventType["linkEvent"] = "linkEvent";
    EventType["messageEvent"] = "messageEvent";
    EventType["signalEvent"] = "signalEvent";
    EventType["terminateEvent"] = "terminateEvent";
    EventType["timerEvent"] = "timerEvent";
    EventType["errorEvent"] = "errorEvent";
})(EventType = exports.EventType || (exports.EventType = {}));
//# sourceMappingURL=Constants.js.map